import { render, staticRenderFns } from "./ListTab.vue?vue&type=template&id=3e464977&scoped=true&"
import script from "./ListTab.vue?vue&type=script&lang=js&"
export * from "./ListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e464977",
  null
  
)

export default component.exports